export const LoanConditionInfoTableTestIds = {
  LOAN_CONDITION_SLA_GROUP_TABLE: 'loan-condition-sla-group.table',
};
